// https://stackoverflow.com/a/38137215
const emailRegex =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.?[a-zA-Z](-?[a-zA-Z0-9])+$/;

// https://github.com/manishsaraan/email-validator/blob/master/index.js
export const isValidEmail = () => (value: string) => {
  if (!value) {
    return true;
  }

  const emailParts = value.split("@");

  if (emailParts.length !== 2) {
    return false;
  }

  const account = emailParts[0];
  const address = emailParts[1];

  if (account.length > 64) {
    return false;
  } else if (address.length > 255) {
    return false;
  }

  const domainParts = address.split(".");

  if (
    domainParts.some(function (part) {
      return part.length > 63;
    })
  ) {
    return false;
  }
  return emailRegex.test(value);
};
